var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"path-duplicate-action"},[_c('pendo-icon-button',{attrs:{"tooltip":"Copy","icon":"copy"},on:{"click":_vm.duplicateReport}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }